import { Link } from 'react-router-dom';
import { FiArrowUp } from 'react-icons/fi';
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaYoutube } from 'react-icons/fa';

const Footer = () => {
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  const footerLinks = [
    {
      title: 'Company',
      links: [
        { name: 'About', href: '/about' },
        { name: 'Products', href: '/products' },
        { name: 'Careers', href: '/careers' },
        { name: 'Contact', href: '/contact' },
      ],
    },
    {
      title: 'Solutions',
      links: [
        { name: 'Technology', href: '/technology' },
        { name: 'Products', href: '/products' },
        { name: 'Enquire', href: '/contact?subject=evaluation' },
      ],
    },
    {
      title: 'Legal',
      links: [
        { name: 'Privacy', href: '/privacy' },
        { name: 'Terms', href: '/terms' },
        { name: 'Cookies', href: '/cookies' },
      ],
    },
  ];

  const socialLinks = [
    { icon: FaLinkedin, href: 'https://www.linkedin.com/company/tavas-industries/about/' },
    { icon: FaTwitter, href: 'https://x.com/tavasindustries' },
    { icon: FaInstagram, href: 'https://www.instagram.com/tavasindustries/' },
    { icon: FaFacebook, href: '#' },
    { icon: FaYoutube, href: '#' },
  ];

  return (
    <footer className="glass-surface-muted backdrop-blur-xl border-t border-slate-200/60 pt-16 pb-8 mt-auto">
      <div className="page-container-wide">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-12 mb-12 pb-12 border-b border-slate-200">
          <div className="sm:col-span-2 lg:col-span-2">
            <Link to="/" className="flex items-center gap-3 mb-5">
              <img src="/Logo.png" alt="Tavas" className="h-9 w-9" />
              <span className="text-sm font-semibold text-slate-900">Tavas Industries</span>
            </Link>
            <p className="body-md text-sm max-w-xs">
              Indigenous assured PNT, CRPA anti-jam, and AI navigation for national security forces.
            </p>
            <div className="flex gap-3 mt-6">
              {socialLinks.map(({ icon: Icon, href }, i) => (
                <a
                  key={i}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 rounded-lg glass-surface flex items-center justify-center text-slate-500 hover:text-cyan-700 hover:border-cyan-200 transition-colors"
                >
                  <Icon size={14} />
                </a>
              ))}
            </div>
          </div>
          {footerLinks.map((col) => (
            <div key={col.title}>
              <h4 className="text-xs font-semibold text-slate-500 uppercase tracking-wide mb-4">{col.title}</h4>
              <ul className="space-y-3">
                {col.links.map((link) => (
                  <li key={link.name}>
                    <Link to={link.href} className="text-sm text-slate-600 hover:text-cyan-700 transition-colors">
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-sm text-slate-500">© {new Date().getFullYear()} Tavas Industries. All rights reserved.</p>
          <button
            type="button"
            onClick={scrollToTop}
            className="flex items-center gap-2 text-sm text-slate-500 hover:text-cyan-700 transition-colors"
          >
            Back to top <FiArrowUp size={14} />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
